import { render } from "./LiquidationAttachments.vue?vue&type=template&id=28faa08a"
import script from "./LiquidationAttachments.vue?vue&type=script&lang=js"
export * from "./LiquidationAttachments.vue?vue&type=script&lang=js"

import "./LiquidationAttachments.vue?vue&type=style&index=0&id=28faa08a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__